import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import {
    CustomerLandingPageContentfulResponse,
    CustomerLandingPageRelayQuery
} from "src/contentful/graphql/customer-landing-page";

import { customerLandingPageRelayQuery } from "@/__generated_contentful__/customerLandingPageRelayQuery.graphql";
import ContentNotFoundErrorBoundary from "@/content/utils/content-not-found-error-boundary";
import { CustomersLandingPageRelayTemplate } from "@/templates/customers/customers-landing-page";

export type CustomerLandingPageProps = {
    queryRef: PreloadedQuery<customerLandingPageRelayQuery>;
};

export const CustomersLandingPage = ({
    queryRef
}: CustomerLandingPageProps) => {
    const preloadedQueryResult = usePreloadedQuery(
        CustomerLandingPageRelayQuery,
        queryRef ||
            (null as unknown as PreloadedQuery<customerLandingPageRelayQuery>)
    );

    const contentfulResponse =
        CustomerLandingPageContentfulResponse(preloadedQueryResult);
    return (
        <ContentNotFoundErrorBoundary>
            <CustomersLandingPageRelayTemplate
                // @ts-ignore
                customerLanding={contentfulResponse}
            />
        </ContentNotFoundErrorBoundary>
    );
};
